import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthServiceService } from '../login/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ReiniciarPassword } from 'src/app/entities/ReiniciarPassword';

@Component({
  selector: 'app-reiniciar-password',
  templateUrl: './reiniciar-password.component.html',
  styleUrls: ['./reiniciar-password.component.scss']
})
export class ReiniciarPasswordComponent {
  minCaracteres = false;
  maxCaracteres = false;
  hasNumber = false;
  hasMinus = false;
  hasMayus = false;
  espCaracter = false;
  public usuarioForm:FormGroup;
  public hidePass: boolean = true;
  public hideConfirm: boolean = true;
  constructor( private router:Router,   private route: ActivatedRoute,
    private fb:FormBuilder, private toastr:ToastrService, private authService:AuthServiceService){}

  ngOnInit(){
    this.initForm();
    this.route.queryParamMap
    .subscribe((params) => {
      this.usuarioForm.patchValue(  { 
        ...this.usuarioForm,
        token: params.get("token"),
        correo: params.get("correo")
      });

      // console.log(this.usuarioForm.value);
      
      /*if (this.reiniciarPassword.Correo && this.reiniciarPassword.Token) {
        this.sendEmail = false;
        console.log(this.reiniciarPassword);
      }*/
    })
  }

  initForm() {
		const pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$/
		this.usuarioForm = this.fb.group({
      token: [''],
      correo: [''],
	  passwordGroup: this.fb.group({
		Password: [
		  "",
		  Validators.compose([
			Validators.required,
			Validators.minLength(6),
			Validators.maxLength(16),
			Validators.pattern(
			  "^(?=.*\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*\\W).{6,16}$"
			),
		  ]),
		], 
		ConfirmPassword: [
            "",
            Validators.compose([
              Validators.required,
              Validators.minLength(6),
              Validators.maxLength(16),
              Validators.pattern(
                "^(?=.*\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*\\W).{6,16}$"
              ),
            ]),
          ],
	  },{validator: passwordMatcher}),
	});
	} 


	cambiarContrasena() {
    const control = this.usuarioForm.get("passwordGroup"); 
		if ((control.get('Password').value === control.get('ConfirmPassword').value) && this.usuarioForm.valid) {
      const data: ReiniciarPassword= {
        Token: this.usuarioForm.get('token').value,
        Correo: this.usuarioForm.get('correo').value,
        Password: control.get('Password').value,
        ConfirmPassword: control.get('ConfirmPassword').value,
      }
      
      // console.log(data);
      
			this.authService.ReiniciarPasword(data).pipe(
				finalize(() => {
          this.authService.logout();
          this.router.navigateByUrl('/home/watch')
					// this.toastr.success('Actualización correcta');
				})
			).subscribe(
				(response) => {
          this.router.navigateByUrl('/pages/login/inicio')
          this.toastr.success("Actualización Correcta")
				}
			)
		} else {
			this.toastr.error('Las contraseñas no coinciden o no cumplen los requerimientos')
		}
	}

  onPasswordInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.minCaracteres = value.length >= 6;
    this.maxCaracteres = value.length <= 16;
    this.hasNumber = /\d/.test(value);
    this.hasMinus = /[a-z]/.test(value);
    this.hasMayus = /[A-Z]/.test(value);
    this.espCaracter = /[^\w\d]/.test(value);
  }

  togglePassword(key: string) {
    if (key === "password") {
      this.hidePass = !this.hidePass;
    } else {
      this.hideConfirm = !this.hideConfirm;
    }
  }

}

function passwordMatcher(c: AbstractControl): { [key: string]: boolean } | null {
  const passwordControl = c.get('Password');
  const confirmPasswordControl = c.get('ConfirmPassword');

  if (passwordControl.pristine || confirmPasswordControl.pristine) {
    confirmPasswordControl.setErrors(null);
    return null;
  }

  if (passwordControl.value === confirmPasswordControl.value) {
    confirmPasswordControl.setErrors(null);
    return null;
  }

  confirmPasswordControl.setErrors({ 'match': true });

  return { 'match': true };
}

